/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiGetCompanyRoomOutcomeConfigResponseFromJSON(json) {
    return StreemApiGetCompanyRoomOutcomeConfigResponseFromJSONTyped(json, false);
}
export function StreemApiGetCompanyRoomOutcomeConfigResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'roomOutcomeConfigUrl': !exists(json, 'room_outcome_config_url') ? undefined : json['room_outcome_config_url'],
        'fileName': !exists(json, 'file_name') ? undefined : json['file_name'],
    };
}
export function StreemApiGetCompanyRoomOutcomeConfigResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'room_outcome_config_url': value.roomOutcomeConfigUrl,
        'file_name': value.fileName,
    };
}
//# sourceMappingURL=StreemApiGetCompanyRoomOutcomeConfigResponse.js.map